module.exports = __webpack_public_path__ + "media/images/mailer/logo-db7984365bc746d276cd8553105bf8b8.png";